import { differenceInSeconds, addSeconds } from 'date-fns'
import formatDuration from 'app/functions/formatDuration'
import Clock from 'app/components/Clock'

export default ({ size = 'big', seconds, onTimeout, enabled }) => {
  const [currentDisplay, setCurrentDisplay] = useState('00:00')
  const [finishAt, setFinishAt] = useState(null)

  useEffect(() => {
    const newFinishAt = addSeconds(new Date(), seconds + 2)

    setFinishAt(newFinishAt)
  }, [seconds])

  useEffect(() => {
    if (!enabled) return

    const interval = setInterval(() => {
      let newSeconds = differenceInSeconds(finishAt, new Date())

      const formatted = formatDuration(newSeconds)

      if (newSeconds <= 0 && onTimeout) onTimeout()

      setCurrentDisplay(formatted)
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [finishAt, enabled])

  return <Clock size={size} currentDisplay={currentDisplay} />
}
